/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { CreateWithdrawalOptions, CreateWithdrawalResponses } from '../types/CreateWithdrawal'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Requests a USDC withdrawal, holding the quantity from the caller's available balance until it completes or is cancelled. The fee is quoted and locked after admin approval. Idempotent on withdrawal_id; only one withdrawal may be in progress at a time. Restricted to users whose native asset is USDC.
 * @summary Create a USDC withdrawal request
 * {@link /v1/web3/withdrawals}
 */
export function createWithdrawal<ThrowOnError extends boolean = true>(
  options: Options<CreateWithdrawalOptions, ThrowOnError>,
): Unwrappable<RequestResult<CreateWithdrawalResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/web3/withdrawals',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<CreateWithdrawalResponses, ThrowOnError>>,
  )
}
